var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoEnviar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ico-enviar") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "C\\xEDrculo-del-Paciente",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: 9,
    transform: "translate(-1320.000000, -418.000000)",
    fill: "#D1D1D1",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "tabla",
    transform: "translate(298.000000, 220.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "iconos",
    transform: "translate(928.000000, 198.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ico-enviar",
    transform: "translate(94.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.8074799,6.3975907 L15.8490906,0.210136105 C15.6547241,0.00855373248 15.3567963,-0.0547240336 15.0974731,0.0496758565 C14.837143,0.155082798 14.6666107,0.407186639 14.6666107,0.687656394 L14.6666107,3.66691312 L14.4375,3.66691312 C9.50952148,3.66691312 5.49999999,7.67640518 5.49999999,12.6043475 L5.49999999,13.9793374 C5.49999999,14.2982438 5.72457887,14.564111 6.03526309,14.6366202 C6.08578493,14.6493765 6.13613893,14.6549154 6.18649293,14.6549154 C6.44598388,14.6549154 6.69439697,14.5026795 6.81440735,14.2634998 C8.10330202,11.6848901 10.6946869,10.0834767 13.5776215,10.0834767 L14.6666107,10.0834767 L14.6666107,13.0625656 C14.6666107,13.3432032 14.837143,13.5953071 15.0974731,13.6997069 C15.3551178,13.8051138 15.6547241,13.7409969 15.8490906,13.5392467 L21.8074799,7.35179206 C22.0641175,7.08508566 22.0641175,6.6653042 21.8074799,6.3975907 L21.8074799,6.3975907 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.25,22 L2.74999999,22 C1.23384094,22 0,20.766336 0,19.2500202 L0,6.41689294 C0,4.90074502 1.23384094,3.66691312 2.74999999,3.66691312 L5.5,3.66691312 C6.00689696,3.66691312 6.41661074,4.07662385 6.41661074,4.5835171 C6.41661074,5.09041035 6.00689696,5.50012108 5.5,5.50012108 L2.74999999,5.50012108 C2.24394224,5.50012108 1.83322145,5.9108389 1.83322145,6.41689294 L1.83322145,19.2500202 C1.83322145,19.7560742 2.24394224,20.166792 2.74999999,20.166792 L19.25,20.166792 C19.7558899,20.166792 20.1666107,19.7560742 20.1666107,19.2500202 L20.1666107,11.9168526 C20.1666107,11.4099593 20.5763245,11.0000807 21.0832215,11.0000807 C21.5902863,11.0000807 22,11.4099593 22,11.9168526 L22,19.2500202 C22,20.766336 20.766159,22 19.25,22 L19.25,22 Z",
    id: "Path"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoEnviar);
export default __webpack_public_path__ + "static/media/ico-enviar.a737c01c21bc9d10af3ff8b99192bcf3.svg";
export { ForwardRef as ReactComponent };